import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { AppCasinoState, CasinoGameModelExt, CasinoNavigationState } from 'src/domains/casino/state/AppCasino.state';
import { CasinoGamesLoader } from 'src/domains/casino/webview/CasinoGames/category-games/CasinoGamesLoader';
import { CasinoGridWrapper } from './CasinoGames.style';
import { SingleGameExt } from 'src/domains/casino/webview/CasinoGames/single-game-ext/SingleGameExt';
import { InfiniteScrollWrapper } from 'src/domains/casino/webview/infiniteScrollWrapper/InfiniteScrollWrapper';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { JackPotWidget } from 'src/domains/casino/webview/CasinoGames/jack-pot-widget/JackPotWidget';

interface GamesListPropsType {
    appCasinoState: AppCasinoState;
    gameModels: Array<CasinoGameModelExt>;
}

const CasinoGamesList = observer(
    'CasinoGamesList',
    ({ appCasinoState, gameModels }: GamesListPropsType): React.ReactElement => {
        return (
            <InfiniteScrollWrapper
                initAmount={24}
                increaseAmount={12}
            >
                {gameModels.map((gameModel) => {
                    return (
                        <SingleGameExt
                            appCasinoState={appCasinoState}
                            key={gameModel.id}
                            gameModel={gameModel}
                        />
                    );
                })}
            </InfiniteScrollWrapper>
        );
    }
);

export interface CasinoGamesPropsType {
    appCasinoState: AppCasinoState;
    navigationState: CasinoNavigationState;
}

export const CasinoGames = observer('CasinoGames', (props: CasinoGamesPropsType): JSX.Element | null => {
    const { appCasinoState, navigationState } = props;
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    if (navigationState.gamesListToDisplay === 'loading') {
        return <CasinoGamesLoader />;
    }

    if (navigationState.gamesListToDisplay.length === 0) {
        return null;
    }
    const isJackpotBanner =
        configState.casinoJackPot && navigationState.activeTabName?.toLowerCase() === 'jackpot games';

    return (
        <>
            {isJackpotBanner ? <JackPotWidget /> : null}
            <CasinoGridWrapper>
                <CasinoGamesList
                    appCasinoState={appCasinoState}
                    gameModels={navigationState.gamesListToDisplay}
                />
            </CasinoGridWrapper>
        </>
    );
});
